import { useEffect, useState } from "react";
import { CreateTableForUpload } from "../TimeEntriesTables/CreateTableForUpload";

import CloseIcon from "@mui/icons-material/Close";

export function UploadForm({ isOpen,
  onClose,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload }
) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter(i => i.errors.length > 0)

      if (_errorData.length <= 0) {
        setHasNoError(true)
      } else {
        setHasNoError(false)
      }
    }
  }, [data_temp])

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files)
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles])

  const submit = (e) => {
    handleFinalFileUpload(data_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = [
    "Employee Id",
    "Employee Name",
    "Date",
    "Time In",
    "Device In",
    "Time Out",
    "Device Out",
    "Error",
  ]
  var accessor = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "date",
    "timeIn",
    "deviceNameTimeIn",
    "timeOut",
    "deviceNameTimeOut",
    "errors",
  ]

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Time Entries"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div className="popUp-body user-template-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

            </div>

            <div>
              <label htmlFor="fileInput" className='browse'>Browse...</label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: 'none' }}
              />
              <div
                id='drop-files-here'
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  padding: '20px',
                  marginTop: '10px',
                  textAlign: 'center',
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                    <button id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}>
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ?
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white" }}>
                      Data is valid.
                    </div>
                  </>
                  :
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white" }}>
                      Cannot upload with error.
                    </div>
                  </>
                }
                <div className='employeesTab-tab upload-preview-tab' style={{ marginTop: "10px" }}>
                  <div id="container1 table-uploads" className="employeesTab-table container">
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
                  {hasNoError && <button id="add-family"
                    className="save row"
                    onClick={(e) => submit(e)}
                    style={{ marginRight: "5px" }}>
                    UPLOAD
                  </button>}
                  <button id="add-family"
                    className="cancel row"
                    style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                    onClick={() => handleClose()}>
                    CANCEL
                  </button>
                </div>
              </>
            )
            }


          </div>
        )}
      </div>
    </>
  );
}